import React from 'react';

type FormTextAreaProps = {
    label: string;
    name: string;
    value?: string;
    onChange?: (value: string) => void;
    error?: string;
    placeholder?: string;
    disabled?: boolean;
    rows?: number;
};

const FormTextArea = ({ label, name, value, onChange, error, placeholder, disabled, rows = 3 }: FormTextAreaProps) => {
    return (
        <div className="mb-4">
            <label
                htmlFor={name}
                className="block text-sm font-medium mb-1.5"
                style={{ color: 'var(--text-secondary)' }}
            >
                {label}
            </label>
            <textarea
                id={name}
                name={name}
                value={value || ''}
                onChange={(e) => onChange?.(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
                rows={rows}
                className="input-base"
                style={{ resize: 'vertical', minHeight: '60px' }}
            />
            {error && (
                <p className="text-xs mt-1" style={{ color: 'var(--danger)' }}>{error}</p>
            )}
        </div>
    );
};

export default FormTextArea;
